import React from 'react';
import { DEFAULT_STOCK_MAX, DEFAULT_STOCK_MIN } from '../constants';
import { isBelowMin, isReturnOnly, stockLevelPercent } from '../utils';
import { RETURN_ONLY_TITLE } from '../constants';

// Below min the fill would clamp to zero width, which reads identically to "no
// stock at all". It collapses to a dot instead, matching the design.
const DOT_WIDTH = '6px';

const StockLevelCell = ({ row }) => {
    if (isReturnOnly(row.original)) {
        return (
            <span className="text-xs text-muted" title={RETURN_ONLY_TITLE}>
                -
            </span>
        );
    }
    const { inventory_min, inventory_max } = row.original;
    const percent = stockLevelPercent(row.original);
    const belowMin = isBelowMin(row.original);
    const width = belowMin ? DOT_WIDTH : `${percent ?? 0}%`;

    return (
        <div className="flex items-center gap-2">
            <span className="text-xs text-muted">{inventory_min ?? DEFAULT_STOCK_MIN}</span>
            <div className="h-1.5 w-14 overflow-hidden rounded-full bg-muted/20">
                {percent === null && !belowMin ? null : (
                    <div
                        className={`h-full rounded-full ${belowMin ? 'bg-destructive' : 'bg-primary'}`}
                        style={{ width }}
                    />
                )}
            </div>
            <span className="text-xs text-muted">{inventory_max ?? DEFAULT_STOCK_MAX}</span>
        </div>
    );
};

export default StockLevelCell;
